export default {"src":"/_next/static/media/LMND.7e42d705.svg","height":18,"width":18};